<form [formGroup]="form" class="grid">
  <mat-form-field [ngClass]="{ 'warn-value': invalidName }">
    <mat-label>{{ 'COMMON.name' | translate }}</mat-label>
    <input formControlName="name" matInput>
    @if (form.controls.name.hasError('required')) {
      <mat-error>{{ 'COMMON.required' | translate }}</mat-error>
    }
    @if (invalidName) {
      <mat-hint>{{ 'ADDITIONAL_FIELDS.duplicate' | translate }}</mat-hint>
    }
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'COMMON.description' | translate }}</mat-label>
    <input formControlName="description" matInput>
    @if (form.controls.description.hasError('required')) {
      <mat-error>{{ 'COMMON.required' | translate }}</mat-error>
    }
  </mat-form-field>

  @switch (form.controls.type.value) {
    @case ('ADDITIONS_INDEX') {
      <mat-checkbox formControlName="required">{{ 'CONTROLS.required_option' | translate }}</mat-checkbox>
      <app-select formControlName="value">
        <app-select-label>{{ 'COMMON.value' | translate }}</app-select-label>
        @for (addIndex of additionalFields$ | async; track addIndex) {
          <mat-option [value]="addIndex.name">
            {{ addIndex | label:'additional-fields' | async }}
          </mat-option>
        }
      </app-select>
    }
    @case ('ENTITY') {
      <mat-radio-group formControlName="entity"
        class="grid radio-group">
        <mat-radio-button value="good">{{ 'COMMON.product' | translate }}</mat-radio-button>
        <mat-radio-button value="sender">{{ 'QUERY_BUILDER.FIELDS.sender' | translate }}</mat-radio-button>
        <mat-radio-button value="status">{{ 'GROUPERS.status' | translate }}</mat-radio-button>
        <mat-radio-button value="storehouse">{{ 'QUERY_BUILDER.FIELDS.storehouse' | translate }}</mat-radio-button>
      </mat-radio-group>
      @switch (form.controls.entity.value) {
        @case ('good') {
          <app-select formControlName="id">
            <app-select-label>{{ 'COMMON.product' | translate }}</app-select-label>
            @for (good of goods; track good) {
              <mat-option [value]="good.id">{{ good.name }}</mat-option>
            }
          </app-select>
        }
        @case ('sender') {
          <app-select formControlName="id">
            <app-select-label>{{ 'QUERY_BUILDER.FIELDS.sender' | translate }}</app-select-label>
            @for (sender of senders; track sender) {
              <mat-option [value]="sender.id">{{ sender.name }}</mat-option>
            }
          </app-select>
        }
        @case ('status') {
          <app-select formControlName="id">
            <app-select-label>{{ 'GROUPERS.status' | translate }}</app-select-label>
            @for (status of statuses; track status) {
              <mat-option [value]="status.id">{{ status.name }}</mat-option>
            }
          </app-select>
        }
        @case ('storehouse') {
          <app-select formControlName="id">
            <app-select-label>{{ 'QUERY_BUILDER.FIELDS.storehouse' | translate }}</app-select-label>
            @for (storehouse of storehouses; track storehouse) {
              <mat-option [value]="storehouse.id">
                {{ storehouse.name }}
              </mat-option>
            }
          </app-select>
        }
      }
    }
    @case ('FILE') {
      <app-select formControlName="extension">
        <app-select-label>{{ 'CONTROLS.FILE.extension' | translate }}</app-select-label>
        @for (mimeType of mimeTypes; track mimeType) {
          <mat-option [value]="mimeType">{{ mimeType }}</mat-option>
        }
      </app-select>
      <app-file-upload [selectedExtension]="form.controls.extension.value"
        [description]="form.controls.description.value"
        formControlName="value">
      </app-file-upload>
    }
    @case ('NUMERIC') {
      <mat-form-field>
        <mat-label>{{ 'COMMON.value' | translate }}</mat-label>
        <input formControlName="value" matInput type="number">
      </mat-form-field>
    }
    @case ('RULE_SET') {
      <app-filter-with-popover formControlName="value"
        [orderFieldMap]="fieldMap">
      </app-filter-with-popover>
    }
    @case ('SELECTABLE') {
      <mat-checkbox formControlName="required">{{ 'CONTROLS.required_option' | translate }}</mat-checkbox>
      <app-select formControlName="selected" class="select-default">
        <app-select-label>{{ 'COMMON.default_value' | translate }}</app-select-label>
        @for (value of possibleValues; track value) {
          <mat-option [value]="value.controls.value.value">
            {{ value.controls.description.value }}
          </mat-option>
        }
      </app-select>
      <div class="grid">
        <button (click)="addPossibleValue()" color="primary" mat-button>
          <mat-icon>add</mat-icon>
          <mat-label>{{ 'COMMON.add' | translate }}</mat-label>
        </button>
        <div formArrayName="values">
          @for (value of possibleValues; track value; let i = $index) {
            <div [formGroupName]="i.toString()"
              class="grid selectable-item">
              <mat-form-field>
                <mat-label>{{ 'COMMON.value' | translate }}</mat-label>
                <input formControlName="value" matInput>
              </mat-form-field>
              <mat-form-field>
                <mat-label>{{ 'COMMON.description' | translate }}</mat-label>
                <input formControlName="description" matInput>
              </mat-form-field>
              <button (click)="removeValue(i, 'values')" color="warn" mat-icon-button>
                <mat-icon>remove</mat-icon>
              </button>
            </div>
          }
        </div>
      </div>
    }
    @case ('SHORT_TEXT') {
      <mat-form-field>
        <mat-label>{{ 'COMMON.value' | translate }}</mat-label>
        <input formControlName="value" matInput>
      </mat-form-field>
    }
    @case ('SUBSET') {
      <button (click)="addSubset()" mat-button color="primary" class="add-button">
        <mat-icon>add</mat-icon>
        <mat-label>{{ 'COMMON.add' | translate }}</mat-label>
      </button>
      <div class="grid subset-grid" formArrayName="schema">
        @for (form of schemaForms; track form; let i = $index) {
          <div class="grid subset">
            <app-select [formControl]="form.controls.type" (valueChange)="changeSubsetForm(i, $event)">
              <app-select-label>{{ 'COMMON.type' | translate }}</app-select-label>
              @for (type of types; track type) {
                <mat-option [value]="type">{{ type }}</mat-option>
              }
            </app-select>
            <app-addition-form [formGroupName]="i.toString()"
              [fieldMap]="fieldMap"
              [goods]="goods"
              [senders]="senders">
            </app-addition-form>
            <app-button-group>
              <button (click)="removeValue(i, 'schema')" color="warn" mat-stroked-button>{{ 'QUERY_BUILDER.delete' | translate }}</button>
            </app-button-group>
          </div>
        }
      </div>
    }
    @case ('SWITCHABLE') {
      <mat-checkbox formControlName="value">{{ form.controls.description.value || ('COMMON.enable' | translate) }}</mat-checkbox>
    }
    @case ('GROUP') {
      <button (click)="addSubset()" mat-button color="primary" class="add-button">
        <mat-icon>add</mat-icon>
        <mat-label>{{ 'COMMON.add' | translate }}</mat-label>
      </button>
      <div class="grid subset-grid" formArrayName="schema">
        @for (form of schemaForms; track form; let i = $index) {
          <div class="grid subset">
            <app-select [formControl]="form.controls.type" (valueChange)="changeSubsetForm(i, $event)">
              <app-select-label>{{ 'COMMON.type' | translate }}</app-select-label>
              @for (type of types; track type) {
                <mat-option [value]="type">{{ type }}</mat-option>
              }
            </app-select>
            <app-addition-form [formGroupName]="i.toString()"
              [fieldMap]="fieldMap"
              [goods]="goods"
              [senders]="senders">
            </app-addition-form>
            <app-button-group>
              <button (click)="removeValue(i, 'schema')" color="warn" mat-stroked-button>{{ 'QUERY_BUILDER.delete' | translate }}</button>
            </app-button-group>
          </div>
        }
      </div>
    }
  }
</form>
